import { render } from "./RunningTotalMobile.vue?vue&type=template&id=0bbc578c&scoped=true&bindings={\"detailsOpen\":\"data\",\"getTotalPrice\":\"options\",\"getTransportDiscount\":\"options\",\"getBookingDates\":\"options\",\"ISO2Uk\":\"options\",\"toggleTotal\":\"options\"}"
import script from "./RunningTotalMobile.vue?vue&type=script&lang=js"
export * from "./RunningTotalMobile.vue?vue&type=script&lang=js"

import "./RunningTotalMobile.vue?vue&type=style&index=0&id=0bbc578c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bbc578c"

export default script